import React from 'react';
import type { PathwayBlock } from '../../../types';
import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';

interface PlaceholderBlockViewProps {
  block: PathwayBlock;
}

export const PlaceholderBlockView: React.FC<PlaceholderBlockViewProps> = ({ block }) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <div className="bg-white rounded-xl border border-aero-200 p-5 mb-4">
        <h2 className="text-lg font-bold text-aero-900">{block.name}</h2>
        {block.description && <p className="text-sm text-aero-600 mt-1">{block.description}</p>}
      </div>
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="w-16 h-16 bg-aero-100 rounded-full flex items-center justify-center mb-4">
          <Construction className="w-8 h-8 text-aero-400" />
        </div>
        <h3 className="text-base font-semibold text-aero-700 mb-1">{t('candidate.block.placeholder.comingSoon')}</h3>
        <p className="text-sm text-aero-400 max-w-xs">{t('candidate.block.placeholder.comingSoonDesc')}</p>
      </div>
    </div>
  );
};
